import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/articles/src/assets/tabellarischer-lebenslauf.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')